export default __webpack_public_path__ + "42ed66dda086a5ef619ccdfae88d04e5.png";